import React, {useEffect, useState} from 'react';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { Loader } from '@squirrellearningltd/go-teacher-components';
import { GET_STUDENT_QUERY, GET_STUDENT_WEEKLY_TARGETS } from './services/graphql';
import StudentContent from './Components/studentContent';
import moment from 'moment';

const Student = (props) => {
    const getStartOfWeek = (startDay) => {
        const date = new Date();
        // Convert backend day (1–7, where 1 = Monday) to JS day (0–6, where 0 = Sunday)
        const jsStartDay = startDay % 7;
      
        const currentDay = date.getDay(); // JS weekday (0 = Sunday, ..., 6 = Saturday)
        
        // Calculate distance to go back to the desired start of the week
        const diff = (currentDay - jsStartDay + 7) % 7;
      
        // Subtract the difference to get the starting date
        const startOfWeek = new Date(date);
        startOfWeek.setDate(date.getDate() - diff);
        
        return startOfWeek;
    };
    
    const [ student, setStudent] = useState(null);
    const { data, error, loading } = useQuery(GET_STUDENT_QUERY, {
        variables: {
            id: props.id
        },
        fetchPolicy: 'network-only',
    });

    const [
        getStudentWeeklyTargets,
        {
            data: studentWeeklyTargetsData,
        }
    ] = useLazyQuery(GET_STUDENT_WEEKLY_TARGETS, {
        fetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (data) {
            setStudent(data.student);
            getStudentWeeklyTargets({
                variables: {
                    id: props.id,
                    weekStart: moment(getStartOfWeek(data.student.school.weekStart)).format('DD/MM/YYYY'),
                },
            })
        }
    }, [data]);

    useEffect(() => {
        if (studentWeeklyTargetsData) {
            setStudent({
                ...student,
                studentWeeklyTarget: studentWeeklyTargetsData.student.studentWeeklyTarget,
                weeklyStudentReportData: studentWeeklyTargetsData.student.weeklyStudentReportData
            })
        }
    }, [studentWeeklyTargetsData])

    if (error) {
        return <p>{error.message}</p>
    }

    if (loading) {
        return <Loader />
    }

    if (student) {
        return (
            <>
                <StudentContent
                    weekStart={getStartOfWeek(data.student.school.weekStart)}
                    student={student}
                    classInfo={props.location && props.location.state && props.location.state.classInfo}
                    classId={props.location && props.location.state && props.location.state.classId}
                    showNotes={props.location && props.location.state && props.location.state.showNotes }
                />
            </>
        );
    }

    return <></>

}

export default Student;